module.exports = __webpack_public_path__ + "media/product/ctg-1-ac914ed2.png";